export default __webpack_public_path__ + "static/media/service-img.a8f1d223.jpg";